export enum CarrierErrorCodes {
  "CARRIER_NOT_AVAILABLE_FOR_ROUTE" = "CARRIER_NOT_AVAILABLE_FOR_ROUTE",
  "DDP_NOT_ALLOWED" = "DDP_NOT_ALLOWED",
}
